import api from './api';
import { LoginCredentials, AuthTokens, User } from '@/types/auth.types';

export const authService = {

  login: async (credentials: LoginCredentials): Promise<AuthTokens> => {
    const response = await api.post<AuthTokens>('/api/auth/login/', credentials);
    return response.data;
  },

  getUserInfo: async (): Promise<User> => {
    const response = await api.get<User>('/api/users/me/');
    return response.data;
  },

  refreshToken: async (refreshToken: string): Promise<AuthTokens> => {
    const response = await api.post<{ access: string }>('/api/auth/refresh/', { refresh: refreshToken });
    return { access: response.data.access, refresh: refreshToken };
  },
};
